export const getCloseButtonVariant = (alternateTheme) => alternateTheme ? 'standalone-alternate' : 'standalone';
